import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const TermSheetScheduleRowDeleteModalUI = ({
  context, deleteMode, submitted, successMsg, errorList, setErrorList,
  onSubmit, onCancelClick, particular,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Delete schedule row'
    buttonLabel='Yes delete'
    cancelLabel='Cancel delete'
    isOpen={deleteMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <MessageUI label={`Are you sure you want to delete "${particular || 'this row'}"?`} />
  </ModalFormUI>

export default TermSheetScheduleRowDeleteModalUI
